module.exports = __webpack_public_path__ + "img/ic-404.18736fdb.svg";